export const JOB_ROLE_COLORS = [
  '#2563EB', // blue
  '#059669', // green
  '#D97706', // amber
  '#DC2626', // red
  '#7C3AED', // violet
  '#0891B2', // cyan
  '#DB2777', // pink
  '#4B5563', // slate
] as const;
